module.exports = __webpack_public_path__ + "static/img/publicity.239cd1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CopierSelfprinting/publicity.png
// module id = VgqY
// module chunks = 10